export const error = (state) => state.error;
export const isLoading = (state) => state.isLoading;
export const item = (state) => state.item;
export const token = (state) => state.token;
export const items = (state) => state.items;
export const userId = (state) => state.userId;
export const isImpersonating = (state) => !!state.adminToken;
